var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-resource",style:(_vm.bindStyle)},[_c('div',{staticClass:"left"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_c('div',{staticClass:"right"},[_vm._v("\n    "+_vm._s(_vm.time)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }